import React from 'react'
import { getDocumentType } from '../../utils/search/getDocumentType'
import SearchPreviewQuestion from './preview/SearchPreviewQuestion'
import SearchPreviewSet from './preview/SearchPreviewSet'
import SearchPreviewPack from './preview/SearchPreviewPack'
import SearchPreviewFolder from './preview/SearchPreviewFolder'
import SearchPreviewInfo from './preview/SearchPreviewInfo'

// True when the suggestion is the kind of hit that has a library entity to
// preview (set / question / pack / folder, or a recent-cache row that points
// at one of those). Used both here and by the dropdown shell to decide
// whether to render the preview column at all.
export function shouldShowPreviewFor(suggestion) {
  if (!suggestion) return false
  if (suggestion.__quickAction) return false
  if (suggestion.__helpShowMore) return false
  if (suggestion.__external) return false
  if (suggestion.__nav) return false
  if (suggestion.showMore) return false
  if (suggestion.__recent) {
    if (!suggestion.item) return false
    const kind = suggestion.__recentItemType
    return kind === 'set' || kind === 'question'
  }
  return !!getDocumentType(suggestion)
}

// Routes the currently-highlighted suggestion to the right preview component.
// Used both inside the dropdown (sibling of the suggestions list) and on the
// results page right panel — passing the active hit as `suggestion`.
//
// Non-library hits return null in the dropdown so the preview column is
// completely hidden. The results page passes `showEmptyState` to keep a small
// "Highlight a result to preview it" card on screen instead of an empty pane.
function SearchPreviewPane({ suggestion, query, showEmptyState }) {
  if (!shouldShowPreviewFor(suggestion)) {
    if (showEmptyState) {
      return (
        <div className='searchPreviewPane searchPreviewPane--empty'>
          <SearchPreviewInfo variant='empty' query={query} />
        </div>
      )
    }
    return null
  }

  if (suggestion.__recent) {
    const { item, __recentItemType: kind } = suggestion
    if (kind === 'set') {
      const setHit = {
        id: item.id,
        name: item.name,
        questions: item.questions,
        clientModified: item.clientModified,
      }
      return <SearchPreviewSet hit={setHit} />
    }
    if (kind === 'question') {
      return <SearchPreviewQuestion hit={{ id: item.id, ...item }} />
    }
    return null
  }

  const kind = getDocumentType(suggestion)
  if (kind === 'question') return <SearchPreviewQuestion hit={suggestion} />
  if (kind === 'set') return <SearchPreviewSet hit={suggestion} />
  if (kind === 'repo') return <SearchPreviewPack hit={suggestion} />
  if (kind === 'folder') return <SearchPreviewFolder hit={suggestion} />

  return null
}

export default SearchPreviewPane
